var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _g2, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel2Badge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 304,
    viewBox: "0 0 790 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395,
    cy: 394.5,
    rx: 395,
    ry: 48.5,
    fill: "url(#paint0_radial_6927_3125)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 424.532,
    cy: 394.501,
    rx: 254.126,
    ry: 9.7,
    fill: "url(#paint1_radial_6927_3125)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 39.2695H417.467L402.072 269.065H387.053L376.539 39.2695Z",
    fill: "url(#paint2_linear_6927_3125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.539 484.596H417.467L402.072 254.8H387.053L376.539 484.596Z",
    fill: "url(#paint3_linear_6927_3125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M685.002 241.477L685.002 282.404L389.87 267.009L389.87 251.99L685.002 241.477Z",
    fill: "url(#paint4_linear_6927_3125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.001 241.477L106.001 282.404L404.137 267.009L404.137 251.99L106.001 241.477Z",
    fill: "url(#paint5_linear_6927_3125)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M557.974 502.412L522.529 522.876L388.295 259.589L401.302 252.079L557.974 502.412Z",
    fill: "url(#paint6_linear_6927_3125)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.124 0.992189L216.679 21.456L379.079 271.95L392.087 264.44L252.124 0.992189Z",
    fill: "url(#paint7_linear_6927_3125)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M656.448 388.959L635.984 424.403L388.09 263.506L395.599 250.499L656.448 388.959Z",
    fill: "url(#paint8_linear_6927_3125)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 99.4746L118.204 134.919L384.095 270.654L391.605 257.647L138.668 99.4746Z",
    fill: "url(#paint9_linear_6927_3125)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M268.473 522.879L233.028 502.415L393.927 254.522L406.934 262.032L268.473 522.879Z",
    fill: "url(#paint10_linear_6927_3125)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M573.443 21.4531L537.998 0.989276L402.262 266.878L415.27 274.388L573.443 21.4531Z",
    fill: "url(#paint11_linear_6927_3125)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.019 424.402L134.555 388.958L397.844 254.725L405.354 267.732L155.019 424.402Z",
    fill: "url(#paint12_linear_6927_3125)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M671.916 134.92L651.452 99.4755L400.956 261.875L408.466 274.882L671.916 134.92Z",
    fill: "url(#paint13_linear_6927_3125)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M302.533 182.917C302.533 176.197 307.98 170.75 314.7 170.75H475.3C482.019 170.75 487.467 176.197 487.467 182.917V304.275C487.467 308.595 485.177 312.59 481.45 314.773L401.15 361.814C397.352 364.039 392.648 364.039 388.85 361.814L308.55 314.773C304.823 312.59 302.533 308.595 302.533 304.275V182.917Z",
    fill: "url(#paint14_linear_6927_3125)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6927_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.517 202.384C330.517 199.024 333.24 196.301 336.6 196.301H453.4C456.76 196.301 459.483 199.024 459.483 202.384V290.448C459.483 292.554 458.394 294.51 456.604 295.619L398.204 331.799C396.241 333.015 393.759 333.015 391.796 331.799L333.396 295.619C331.606 294.51 330.517 292.554 330.517 290.448V202.384Z",
    fill: "url(#paint15_radial_6927_3125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.517 202.384C330.517 199.024 333.24 196.301 336.6 196.301H453.4C456.76 196.301 459.483 199.024 459.483 202.384V290.448C459.483 292.554 458.394 294.51 456.604 295.619L398.204 331.799C396.241 333.015 393.759 333.015 391.796 331.799L333.396 295.619C331.606 294.51 330.517 292.554 330.517 290.448V202.384Z",
    fill: "url(#paint16_radial_6927_3125)",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.517 202.384C330.517 199.024 333.24 196.301 336.6 196.301H453.4C456.76 196.301 459.483 199.024 459.483 202.384V290.448C459.483 292.554 458.394 294.51 456.604 295.619L398.204 331.799C396.241 333.015 393.759 333.015 391.796 331.799L333.396 295.619C331.606 294.51 330.517 292.554 330.517 290.448V202.384Z",
    fill: "url(#paint17_linear_6927_3125)",
    fillOpacity: 0.2
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M453.4 191.434H336.6C330.552 191.434 325.65 196.337 325.65 202.384V290.448C325.65 294.239 327.611 297.76 330.833 299.756L389.233 335.936C392.766 338.125 397.234 338.125 400.767 335.936L459.167 299.756C462.389 297.76 464.35 294.239 464.35 290.448V202.384C464.35 196.337 459.447 191.434 453.4 191.434Z",
    stroke: "url(#paint18_linear_6927_3125)",
    strokeWidth: 9.73333
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M453.4 185.958H336.6C327.529 185.958 320.175 193.312 320.175 202.383V290.349C320.175 296.022 323.103 301.294 327.919 304.292L386.319 340.653C391.633 343.962 398.367 343.962 403.681 340.653L462.081 304.292C466.897 301.294 469.825 296.022 469.825 290.349V202.383C469.825 193.312 462.471 185.958 453.4 185.958Z",
    stroke: "url(#paint19_linear_6927_3125)",
    strokeWidth: 1.21667
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6927_3125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 330,
    y: 196,
    width: 130,
    height: 137
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M330.517 202.382C330.517 199.022 333.24 196.299 336.6 196.299H453.4C456.76 196.299 459.483 199.022 459.483 202.382V290.446C459.483 292.552 458.394 294.508 456.604 295.617L398.204 331.797C396.241 333.013 393.759 333.013 391.796 331.797L333.396 295.617C331.606 294.508 330.517 292.552 330.517 290.446V202.382Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6927_3125)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_6927_3125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.44 240.598C431.382 244.54 434.068 249.563 435.157 255.031C436.246 260.499 435.691 266.167 433.56 271.319C431.43 276.471 427.82 280.877 423.187 283.978C418.555 287.08 413.106 288.739 407.531 288.746C401.956 288.753 396.503 287.107 391.863 284.017C387.222 280.927 383.602 276.53 381.459 271.383C379.315 266.236 378.746 260.57 379.822 255.099C380.897 249.629 383.571 244.6 387.503 240.647C390.12 238.018 393.23 235.93 396.654 234.504C400.079 233.078 403.752 232.342 407.461 232.337C411.171 232.333 414.845 233.06 418.274 234.477C421.702 235.895 424.817 237.975 427.44 240.598Z",
    fill: "url(#paint20_radial_6927_3125)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.62 238.015C377.939 238.301 372.582 240.743 368.64 244.843C364.698 248.943 362.469 254.392 362.406 260.079C362.343 265.766 364.451 271.263 368.302 275.45C372.152 279.636 377.454 282.196 383.126 282.608C377.58 276.478 374.55 268.481 374.641 260.215C374.733 251.948 377.939 244.021 383.62 238.015Z",
    fill: "url(#paint21_radial_6927_3125)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.537 246.341C357.917 246.891 354.625 248.754 352.29 251.574C349.954 254.395 348.738 257.976 348.872 261.635C349.006 265.294 350.482 268.776 353.017 271.418C355.553 274.06 358.972 275.676 362.623 275.96C359.586 271.661 357.867 266.572 357.674 261.312C357.481 256.053 358.823 250.851 361.537 246.341Z",
    fill: "url(#paint22_radial_6927_3125)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.583 237.326C386.536 237.128 386.47 236.932 386.382 236.742C385.862 235.613 384.708 234.914 383.467 234.977C377.013 235.302 370.926 238.077 366.448 242.735C365.696 243.517 364.999 244.342 364.359 245.205C364.281 245.012 364.183 244.826 364.064 244.649C363.408 243.669 362.245 243.157 361.08 243.334C356.721 243.996 352.759 246.239 349.947 249.634C347.135 253.03 345.671 257.341 345.832 261.746C345.994 266.152 347.77 270.344 350.823 273.524C353.876 276.705 357.992 278.651 362.387 278.993C363.563 279.084 364.685 278.488 365.268 277.463C365.371 277.281 365.454 277.091 365.517 276.896C365.695 277.103 365.877 277.307 366.063 277.509C370.437 282.265 376.461 285.174 382.906 285.642C384.145 285.732 385.315 285.059 385.86 283.942C385.961 283.735 386.037 283.52 386.088 283.302C387.352 284.491 388.719 285.578 390.177 286.549C395.318 289.972 401.358 291.796 407.535 291.788C413.711 291.78 419.747 289.942 424.88 286.506C430.012 283.07 434.011 278.189 436.371 272.481C438.731 266.773 439.347 260.494 438.14 254.436C436.933 248.379 433.958 242.815 429.591 238.447C426.685 235.541 423.234 233.237 419.436 231.667C415.638 230.096 411.567 229.29 407.458 229.295C403.348 229.301 399.279 230.116 395.485 231.696C392.217 233.057 389.207 234.962 386.583 237.326Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 6.08333,
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M397.434 262C397.434 264.905 398.587 267.69 400.641 269.743C402.694 271.797 405.479 272.95 408.384 272.95C408.384 266.867 403.48 262 397.434 262ZM408.384 252.875C409.19 252.875 409.964 253.196 410.534 253.766C411.105 254.337 411.425 255.11 411.425 255.917C411.425 256.724 411.105 257.497 410.534 258.068C409.964 258.638 409.19 258.959 408.384 258.959C407.577 258.959 406.803 258.638 406.233 258.068C405.662 257.497 405.342 256.724 405.342 255.917C405.342 255.11 405.662 254.337 406.233 253.766C406.803 253.196 407.577 252.875 408.384 252.875ZM400.597 258.655C400.597 259.461 400.917 260.235 401.488 260.805C402.058 261.376 402.832 261.696 403.639 261.696C404.283 261.696 404.88 261.489 405.342 261.161V261.392C405.342 262.199 405.662 262.972 406.233 263.543C406.803 264.113 407.577 264.434 408.384 264.434C409.19 264.434 409.964 264.113 410.534 263.543C411.105 262.972 411.425 262.199 411.425 261.392V261.161C411.888 261.489 412.484 261.696 413.129 261.696C413.935 261.696 414.709 261.376 415.279 260.805C415.85 260.235 416.17 259.461 416.17 258.655C416.17 257.438 415.452 256.404 414.43 255.917C415.452 255.43 416.17 254.384 416.17 253.18C416.17 252.373 415.85 251.599 415.279 251.029C414.709 250.458 413.935 250.138 413.129 250.138C412.484 250.138 411.888 250.333 411.425 250.673V250.442C411.425 249.635 411.105 248.862 410.534 248.291C409.964 247.721 409.19 247.4 408.384 247.4C407.577 247.4 406.803 247.721 406.233 248.291C405.662 248.862 405.342 249.635 405.342 250.442V250.673C404.88 250.333 404.283 250.138 403.639 250.138C402.832 250.138 402.058 250.458 401.488 251.029C400.917 251.599 400.597 252.373 400.597 253.18C400.597 254.384 401.315 255.43 402.337 255.917C401.315 256.404 400.597 257.438 400.597 258.655ZM408.384 272.95C411.288 272.95 414.073 271.797 416.126 269.743C418.18 267.69 419.334 264.905 419.334 262C413.25 262 408.384 266.867 408.384 272.95Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6927_3125",
    x: 320.783,
    y: 186.568,
    width: 148.434,
    height: 155.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.23559 0 0 0 0 0.238151 0 0 0 0 0.245833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6927_3125"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_6927_3125",
    x: 339.129,
    y: 226.254,
    width: 106.305,
    height: 77.0928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.86667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.825
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6927_3125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6927_3125",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.21667,
    dy: 2.43333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.51667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.205833 0 0 0 0 0.209444 0 0 0 0 0.216667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6927_3125"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 394.5) rotate(90) scale(48.5 395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDFE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.532 394.501) rotate(90) scale(9.7 254.126)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707073"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDFE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6927_3125",
    x1: 397.003,
    y1: 39.2695,
    x2: 397.003,
    y2: 269.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6927_3125",
    x1: 397.003,
    y1: 484.596,
    x2: 397.003,
    y2: 254.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6927_3125",
    x1: 657.591,
    y1: 261.94,
    x2: 389.87,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6927_3125",
    x1: 110.131,
    y1: 261.94,
    x2: 404.137,
    y2: 261.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6927_3125",
    x1: 526.546,
    y1: 488.906,
    x2: 392.687,
    y2: 257.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6927_3125",
    x1: 236.466,
    y1: 14.8011,
    x2: 383.467,
    y2: 269.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6927_3125",
    x1: 622.478,
    y1: 392.976,
    x2: 390.625,
    y2: 259.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6927_3125",
    x1: 132.013,
    y1: 119.262,
    x2: 386.629,
    y2: 266.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6927_3125",
    x1: 264.456,
    y1: 488.909,
    x2: 398.315,
    y2: 257.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6927_3125",
    x1: 553.655,
    y1: 14.7982,
    x2: 406.654,
    y2: 269.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6927_3125",
    x1: 168.525,
    y1: 392.975,
    x2: 400.378,
    y2: 259.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6927_3125",
    x1: 658.107,
    y1: 119.263,
    x2: 403.492,
    y2: 266.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED402",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED402",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6927_3125",
    x1: 313.483,
    y1: 170.75,
    x2: 405.342,
    y2: 358.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(395 268.084) rotate(90) scale(111.816 106.131)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9DA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67676A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(364.864 241.856) rotate(-45.741) scale(72.2806 38.3647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6927_3125",
    x1: 395,
    y1: 196.301,
    x2: 395,
    y2: 339.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6927_3125",
    x1: 395,
    y1: 196.301,
    x2: 395,
    y2: 339.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFE3EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6927_3125",
    x1: 353.633,
    y1: 181.091,
    x2: 417.508,
    y2: 342.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4D6D9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.711 247.382) rotate(-176.465) scale(67.581 155.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6D7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.711 247.382) rotate(-176.465) scale(67.581 155.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6D7A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_6927_3125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(423.711 247.382) rotate(-176.465) scale(67.581 155.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6D7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel2Badge);
export default __webpack_public_path__ + "static/media/Level2Badge.a57f72f3dc6984e2f0bdf513fbf767a3.svg";
export { ForwardRef as ReactComponent };